module.exports = __webpack_public_path__ + "img/Roberto_Raddi.3b76bd3e.png";